import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Spinner,
} from "@fluentui/react-components";
import { getCategories } from "api";
import { ConstantValues } from "common/constants";
import { ICategory } from "models/ICategory";
import { useEffect, useState } from "react";
import { NHColors } from "utils/generalUtils";
import { useStyles } from "./viewPromptDialog.styles";
import { IViewPromptDialogProps } from "./viewPromptDialog.types";

export const ViewPromptDialog = (
  props: IViewPromptDialogProps,
): JSX.Element => {
  const styles = useStyles();
  const [categories, setCategories] = useState<ICategory[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchCategories = async () => {
      if (
        !props.preselectedKnowledgeComponents ||
        props.preselectedKnowledgeComponents.length === 0
      ) {
        return;
      }

      try {
        setLoading(true);
        const fetchedCategories = await getCategories(true);
        setCategories(fetchedCategories);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    if (props.open) {
      fetchCategories();
    }
  }, [props.open, props.preselectedKnowledgeComponents]);

  const selectedKnowledgeComponentNames = (
    props.preselectedKnowledgeComponents || []
  )
    .map((id) => {
      for (const cat of categories) {
        const tag = cat.tags.find((t) => t.id === id);
        if (tag) return tag.name;
      }
      return null;
    })
    .filter((name): name is string => !!name);

  return (
    <Dialog
      open={props.open}
      modalType="modal"
      onOpenChange={(_, d) => !d.open && props.onClose()}
    >
      <DialogSurface className={styles.surface}>
        <DialogBody>
          <DialogTitle>{props.title || "Prompt"}</DialogTitle>

          <DialogContent className={styles.content}>
            <div
              className={styles.richText}
              dangerouslySetInnerHTML={{
                __html: props.promptHtml || ConstantValues.EMPTY_STRING,
              }}
            />

            {props.preselectedKnowledgeComponents &&
              props.preselectedKnowledgeComponents.length > 0 && (
                <div
                  style={{
                    marginTop: "16px",
                    padding: "12px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "4px",
                  }}
                >
                  <div style={{ fontWeight: 600, marginBottom: "8px" }}>
                    Preselected Knowledge Components:
                  </div>
                  {loading ? (
                    <Spinner size="tiny" label="Loading..." />
                  ) : selectedKnowledgeComponentNames.length > 0 ? (
                    <div
                      style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                    >
                      {selectedKnowledgeComponentNames.map((name, index) => (
                        <span
                          key={index}
                          style={{
                            padding: "4px 8px",
                            backgroundColor: NHColors.primary,
                            color: "white",
                            borderRadius: "4px",
                            fontSize: "12px",
                          }}
                        >
                          {name}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <span style={{ fontSize: "12px", color: "#666" }}>
                      No knowledge components selected
                    </span>
                  )}
                </div>
              )}
          </DialogContent>

          <DialogActions>
            <Button appearance="primary" onClick={props.onClose}>
              Close
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
